import $ from 'jquery';
import slick from 'slick-carousel'
import magnificpopup from 'magnific-popup'
import 'bootstrap/js/dist/alert'
import 'bootstrap/js/dist/collapse'
require('./jquery-ui.js') // Require Other Script(s) from app/js folder Example
require('./bootstrap-datepicker.min.js')
